import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import PriceRolloutChoice from "./PriceRolloutChoice";

/**
 * The rollout choice in a dialog of its own, for the vendor-approval screen,
 * where approving is a single action with nothing else to confirm.
 *
 * Admin Products does NOT use this: there the choice is rendered inline inside
 * the submit confirmation, so the admin sees the warning and the choice in one
 * place instead of clicking through two dialogs.
 *
 * Everything the choice knows lives in PriceRolloutChoice; this is the shell.
 */
export default function PriceRolloutDialog({
  open,
  onClose,
  onConfirm,
  /** The offers whose price this save changes. Candidates are loaded per id. */
  priceIds = [],
  title = "Who is this price for?",
  confirmLabel = "Publish",
  busy = false,
}) {
  const [rollout, setRollout] = useState({
    mode: "new_only",
    subscription_ids: [],
    note: null,
  });
  const [valid, setValid] = useState(true);

  return (
    <Dialog
      open={!!open}
      onClose={busy ? undefined : onClose}
      maxWidth="md"
      fullWidth
      // Above the listing-editor overlay (z-index 2000), which is well over
      // MUI's default 1300.
      sx={{ zIndex: 3000 }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        {/* Remounted per open so a cancelled choice never leaks into the next
            one — the choice keeps its own state. */}
        {open && (
          <PriceRolloutChoice
            priceIds={priceIds}
            busy={busy}
            onChange={setRollout}
            onValidityChange={setValid}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => onConfirm(rollout)}
          disabled={busy || !valid}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
